//--------------------------------------
// load character characteristic values
//--------------------------------------
export default function loadCharacterCharacteristicValues(characters) {
  console.log('-----------------------------------------')
  console.log('IN loadCharacterCharacteristicValues...')
  //----------------------
  // loop thru characters
  //----------------------
  for (let i = 0; i < characters.length; i++) {
    //-----------
    // get chars
    //-----------
    let chars = characters[i].characteristics
    if (chars.length > 0) {
      // -------------------------------------------------
      // load existing char values where exist (catchall)
      // -------------------------------------------------
      chars.forEach((c) => {
        // console.log("char= " + c.name + " cur = " + c.cur);
        switch (c.name) {
          //
          case 'str':
            characters[i].str_cur = c.cur
            characters[i].str_improvs_tot = c.improvs_tot
            characters[i].str_rolled = c.rolled
            characters[i].str_incr_percent = c.incr_percent
            characters[i].str_adjs_tot = c.adjs_tot
            break
          //
          case 'con':
            characters[i].con_cur = c.cur
            characters[i].con_improvs_tot = c.improvs_tot
            characters[i].con_rolled = c.rolled
            characters[i].con_incr_percent = c.incr_percent
            characters[i].con_adjs_tot = c.adjs_tot
            characters[i].con_wounds_tot = characters[i].wounds ?? 0
            break
          //
          case 'dex':
            characters[i].dex_cur = c.cur
            characters[i].dex_improvs_tot = c.improvs_tot
            characters[i].dex_rolled = c.rolled
            characters[i].dex_incr_percent = c.incr_percent
            characters[i].dex_adjs_tot = c.adjs_tot
            break
          //
          case 'siz':
            characters[i].siz_cur = c.cur
            characters[i].siz_improvs_tot = c.improvs_tot
            characters[i].siz_rolled = c.rolled
            characters[i].siz_incr_percent = c.incr_percent
            characters[i].siz_adjs_tot = c.adjs_tot
            break
          //
          case 'int':
            characters[i].int_cur = c.cur
            characters[i].int_improvs_tot = c.improvs_tot
            characters[i].int_rolled = c.rolled
            characters[i].int_incr_percent = c.incr_percent
            characters[i].int_adjs_tot = c.adjs_tot
            break
          //
          case 'pow':
            characters[i].pow_cur = c.cur
            characters[i].pow_improvs_tot = c.improvs_tot
            characters[i].pow_rolled = c.rolled
            characters[i].pow_incr_percent = c.incr_percent
            characters[i].pow_integs_tot = c.integs_tot
            characters[i].pow_adjs_tot = c.adjs_tot
            break
          //
          case 'cha':
            characters[i].cha_cur = c.cur
            characters[i].cha_improvs_tot = c.improvs_tot
            characters[i].cha_rolled = c.rolled
            characters[i].cha_incr_percent = c.incr_percent
            characters[i].cha_adjs_tot = c.adjs_tot
            break
          //
          default:
        }
      })
    }
  }
  return characters
}
